import { ConfirmationDesktop } from "./Confirmation-desktop";

export const Confirmation = () => {
  return <ConfirmationDesktop />;
};
